import _ from 'lodash';
import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';



export function useContinueNavState() {
  const [searchParams] = useSearchParams();
  const state = useMemo(() => {
    const continueValue = searchParams.get('continue');

    if (continueValue && _.isString(continueValue)) {
      return {
        continueValue
      };
    }

    return undefined;
  }, [searchParams]);

  return state;
}
